import * as React from 'react'
import { useSelector } from 'react-redux'
import { Formik } from 'formik'
import { selectGainMoreCustomers } from '@user/store/dashboard/widgets/gainMoreCustomers/slice'
import { useGetSalesTeamListOnMount } from '@user/store/salesTeam/hooks'
import {
  flipCard,
  setAssigneeIds,
  setSalesTeamsIds,
} from '@user/store/dashboard/widgets/gainMoreCustomers/slice'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { SettingsForm } from './SettingsForm'
import { useHandleSubmit, useInitData } from '../../hooks'

export function ContentBack() {
  const teamStatus = useGetSalesTeamListOnMount()
  const widgetData = useSelector(selectGainMoreCustomers)
  const { handleGainMoreCustomersSubmit } = useHandleSubmit({
    flipCard,
    setAssigneeIds,
    setSalesTeamsIds,
  })
  const { initSalesTeams, initOwnersIds, initSalesTeamsIds, loadingUsers } =
    useInitData(widgetData)

  return (
    <>
      {teamStatus === 'pending' && loadingUsers && (
        <Box p={2} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      )}

      {teamStatus === 'fail' && <Alert>Failed to load widget settings.</Alert>}

      {teamStatus === 'success' && !loadingUsers && (
        <Formik
          initialValues={{
            assigneeIds: initOwnersIds,
            salesTeamIds: initSalesTeamsIds,
          }}
          onSubmit={handleGainMoreCustomersSubmit}
        >
          <SettingsForm
            testIdPrefix="gain-more-customers-widget"
            salesTeams={initSalesTeams}
            assigneeIds={widgetData.assigneeIds}
            initData={{
              assigneeIds: initOwnersIds,
              salesTeamIds: initSalesTeamsIds,
            }}
          />
        </Formik>
      )}
    </>
  )
}
